import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { SCREEN } from 'router/screens';

import {
    selectActiveFavouriteChannelsList,
    selectFavouriteChannelsList,
} from 'store/user/selectors';

import {
    SETTINGS_CHANNEL_LINEUP_CLEAR_MY_LIST,
    SETTINGS_CHANNEL_LINEUP_MY_LIST,
    SETTINGS_CHANNEL_LINEUP_STANDARD_LIST,
    SETTINGS_CHANNEL_SCAN_CHOOSE_BETWEEN_LISTS_BUTTON,
    SETTINGS_CHANNEL_SCAN_CUSTOMIZE_MY_LIST_BUTTON,
} from '../languagesConst';
import { ChannelsLineup } from '../types';

function useChannelsLineups() {
    const myList = useSelector(selectFavouriteChannelsList);
    const myListIsActive = useSelector(selectActiveFavouriteChannelsList);

    const channelsLineups = useMemo<ChannelsLineup[]>(() => {
        return [
            {
                id: SETTINGS_CHANNEL_LINEUP_STANDARD_LIST,
                title: SETTINGS_CHANNEL_LINEUP_STANDARD_LIST,
                selected: !myListIsActive,
            },
            {
                id: SETTINGS_CHANNEL_LINEUP_MY_LIST,
                title: SETTINGS_CHANNEL_LINEUP_MY_LIST,
                selected: !!myListIsActive,
            },
        ];
    }, [myListIsActive]);

    const myListOption = useMemo<ChannelsLineup>(
        () =>
            myList
                ? {
                      id: SETTINGS_CHANNEL_LINEUP_MY_LIST,
                      title: SETTINGS_CHANNEL_LINEUP_MY_LIST,
                      screen: SCREEN.MY_LIST,
                  }
                : {
                      id: SETTINGS_CHANNEL_LINEUP_MY_LIST,
                      title: SETTINGS_CHANNEL_LINEUP_MY_LIST,
                  },
        [myList],
    );

    const channelsList = useMemo<ChannelsLineup[]>(
        () => [
            {
                id: SETTINGS_CHANNEL_LINEUP_STANDARD_LIST,
                title: SETTINGS_CHANNEL_LINEUP_STANDARD_LIST,
                screen: SCREEN.STANDARD_LIST,
            },
            myListOption,
            {
                id: SETTINGS_CHANNEL_SCAN_CHOOSE_BETWEEN_LISTS_BUTTON,
                title: SETTINGS_CHANNEL_SCAN_CHOOSE_BETWEEN_LISTS_BUTTON,
                screen: SCREEN.SWITCH_CHANNEL_LIST,
            },
        ],
        [myListOption],
    );

    const myListOptions = useMemo<ChannelsLineup[]>(
        () => [
            {
                id: SETTINGS_CHANNEL_SCAN_CUSTOMIZE_MY_LIST_BUTTON,
                title: SETTINGS_CHANNEL_SCAN_CUSTOMIZE_MY_LIST_BUTTON,
                screen: SCREEN.EDIT_MY_LIST,
            },
            {
                id: SETTINGS_CHANNEL_LINEUP_CLEAR_MY_LIST,
                title: SETTINGS_CHANNEL_LINEUP_CLEAR_MY_LIST,
            },
        ],
        [],
    );

    const selectedChannelsLineup = useMemo(
        () => channelsLineups.find(({ selected }) => selected),
        [channelsLineups],
    );

    return {
        myList,
        channelsLineups,
        channelsList,
        selectedChannelsLineup,
        myListIsActive,
        myListOptions,
    };
}

export default useChannelsLineups;
